export const routes = [

  {
    path: '/inscricao',
    component: () => import(/* webpackChunkName: "administrative-dashboard" */ './components/inicialPage'),
    name: 'inscricao.inicio'
  }

]
